import React from "react";
import logo from "../../assets/images/icons/pg-hdr-logo-ikea.svg";

export default function Header() {
    return (
        <header id="pg-hdr">
            <div className="pg-hdr-wrapper">
                <nav className="navbar navbar-expand-lg">
                    <div className="container-fluid">
                        <div className="navbar-primary">
                            <div className="navbar-brand">
                                <img src={logo} alt="IKEA" title="IKEA" />
                            </div>
                            <div className="navbar-title">AutoMail</div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    );
}